import { Image } from "react-bootstrap";
import "../../assets/scss/components/sections/resumes/skills.scss";

import email from "../../assets/images/resume/email.svg";
import fb from "../../assets/images/resume/fb.svg";
import insta from "../../assets/images/resume/insta.svg";
import tiktok from "../../assets/images/resume/tiktok.svg";
import { keySkills, tags, targetJobTitles } from "./data/data";

const Skills = ({ isLoading, skillsData }) => {
  const getRandomWidth = () => {
    const min = 60; // min width in px
    const max = 200; // max width in px
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  return (
    <div className="skills-section">
      {isLoading ? (
        <div className="loading">
          <div className="skills">
            <h6 className="heading-6">Key Skills</h6>
            <div className="skills-array">
              {keySkills.map((skill) => {
                const randomWidth = getRandomWidth();
                return (
                  <div
                    className="skill shimmer"
                    style={{ width: `${randomWidth}px` }}
                  ></div>
                );
              })}
            </div>
          </div>
          <div className="skills">
            <h6 className="heading-6">Target Job Titles</h6>
            <div className="skills-array">
              {targetJobTitles.map((skill) => {
                const randomWidth = getRandomWidth();
                return (
                  <div
                    className="skill shimmer"
                    style={{ width: `${randomWidth}px` }}
                  ></div>
                );
              })}
            </div>
          </div>
          <div className="skills">
            <h6 className="heading-6">Tags</h6>
            <div className="skills-array">
              {tags.map((skill) => {
                const randomWidth = getRandomWidth();
                return (
                  <div
                    className="skill shimmer"
                    style={{ width: `${randomWidth}px` }}
                  ></div>
                );
              })}
            </div>
          </div>
          <div className="social-icons">
            <a>
              <div className="social shimmer"></div>
            </a>
            <a>
              <div className="social shimmer"></div>
            </a>
            <a>
              <div className="social shimmer"></div>
            </a>
            <a>
              <div className="social shimmer"></div>
            </a>
          </div>
        </div>
      ) : (
        <div>
          <div className="skills">
            <h6 className="heading-6">Key Skills</h6>
            <div className="skills-array">
              {skillsData?.key_skills_focus.map((skill) => (
                <div className="skill">{skill}</div>
              ))}
            </div>
          </div>
          <div className="skills">
            <h6 className="heading-6">Target Job Titles</h6>
            <div className="skills-array">
              {skillsData?.target_job_titles.map((skill) => (
                <div className="skill">{skill}</div>
              ))}
            </div>
          </div>
          <div className="skills">
            <h6 className="heading-6">Tags</h6>
            <div className="skills-array">
              {skillsData?.tags.map((skill) => (
                <div className="skill">{skill}</div>
              ))}
            </div>
          </div>
          <div className="social-icons">
            <a>
              <div className="social">
                <Image src={email} />
              </div>
            </a>
            <a>
              <div className="social">
                <Image src={fb} />
              </div>
            </a>
            <a>
              <div className="social">
                <Image src={insta} />
              </div>
            </a>
            <a>
              <div className="social">
                <Image src={tiktok} />
              </div>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Skills;
